import { render, staticRenderFns } from "./IndustryView.vue?vue&type=template&id=7f8e8f4f&lang=pug&"
import script from "./IndustryView.vue?vue&type=script&lang=js&"
export * from "./IndustryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports